import request from '@/utils/request'

export const changePassword = params =>
  request.post('/masterdata-api/user/password/modify', params)

export const logout = () => request.get('/masterdata-api/logout')
export const getTableData = params =>
  request.post('/customer-api/customer/page', params)
export const getTranList = params =>
  request.post('/workflow-api/credit-apply/applylist/page', params)
export const getRecentLog = params =>
  request.post('/customer-api/company-search-logs/add', params)
